import getThreadsById from '@/lib/threads/getThreadsById.js';
import upsertSortedThread from '@/lib/threads/upsertSortedThread.js';

const applyThreadPinMutation = ({ state, threadId, pinned, updatedAt }) => {
  if (!threadId) {
    return state;
  }

  const existingMeta = getThreadsById(state.threads)?.[threadId];

  if (!existingMeta) {
    return state;
  }

  const nextPinned = Boolean(pinned);
  const nextPinnedAt = updatedAt || existingMeta.pinnedAt || new Date().toISOString();
  const nextThreadMeta = {
    ...existingMeta,
    pinned: nextPinned,
    pinnedAt: nextPinned ? nextPinnedAt : null,
    updatedAt: existingMeta.updatedAt || null
  };

  return {
    ...state,
    threads: upsertSortedThread(state.threads, nextThreadMeta)
  };
};

export default applyThreadPinMutation;
